import React from "react";
import Sugar from 'sugar';

import image from '../assets/img/elements/no-results.jpg';

Sugar.extend();

function SearchNoResults({}) {

  return (
    <div className="search-no-results">
      <img src={ image }/>
      <br/>
      No results found. Try a different search!
    </div>
  );
}


export default SearchNoResults;
